<!-- 本年度各险种报案与理赔情况 -->
<template>
	<div :id="id" class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
import moment from 'moment';
let chart = null;
export default {
	name: 'SettlementClaimsChart',
	props: {
		id: {
			type: String,
			required: false,
			default: 'SettlementClaimsChart'
		},
		subtext: {
			type: String,
			required: false,
			default: moment().format('YYYY年MM月DD日')
		}
	},
	data() {
		return {
			// id: 'SettlementClaimsChart',//地图渲染容器id
			option: {
				title: {
					text: '(左柱投保面积，中柱报案面积，右柱理赔面积)',//主标题
					textStyle: {
						//主标题的属性
						color: 'rgba(0, 0, 0, 0.4)', //颜色
						fontSize: 12, //大小
					},
					subtext: '(2020年)',
					left: 'right',
					 // textAlign: 'auto',//整体（包括 text 和 subtext）的水平对齐
				},
				tooltip: {
					trigger: 'axis'
				},
				dataset: {
				// 	dimensions: [
				// 		'month',
				// 		'水稻政策性保险投保面积',
				// 		'大豆政策性保险投保面积',
				// 		'玉米政策性保险投保面积',
				// 		'水稻政策性保险报案面积',
				// 		'大豆政策性保险报案面积',
				// 		'玉米政策性保险报案面积',
				// 		'水稻政策性保险理赔面积',
				// 		'大豆政策性保险理赔面积',
				// 		'玉米政策性保险理赔面积'
				// 	],
				// 	source: [
				// 		{ month: '1月', 水稻政策性保险投保面积: 0, 大豆政策性保险投保面积: 0, 玉米政策性保险投保面积: 0,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '2月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '3月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '4月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '5月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '6月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '7月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '8月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '9月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '10月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '11月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				// 		{ month: '12月', 水稻政策性保险投保面积: 1000, 大豆政策性保险投保面积: 1500, 玉米政策性保险投保面积: 1200,水稻政策性保险报案面积: 1400, 大豆政策性保险报案面积: 1700, 玉米政策性保险报案面积: 1800,水稻政策性保险理赔面积: 1900, 大豆政策性保险理赔面积: 2000, 玉米政策性保险理赔面积: 3100 },
				
				// 	]
				},
				// dataZoom: [{//区域缩放，显示不全的时候
				//   type: 'slider',//slider表示有滑动块的，inside表示内置的
				//   show: false, //flase直接隐藏图形
				//   xAxisIndex: [0],
				//   left: '9%', //滚动条靠左侧的百分比
				//   bottom: -5,
				//   start: 0,//滚动条的起始位置
				//   end: 50 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
				// }],
				legend: {
					top: 20,
					// left: 10,
					itemGap: 20,
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
						color: '#333'
					},
					icon: 'rect',
					//data: ['水稻政策性保险', '大豆政策性保险', '玉米政策性保险']
				},
				grid: {
					left: 50,
					right: 5,
					top:90
				},
				toolbox: {
					show: true
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						//data: ['1月 ', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#aaa',
								type: 'dotted'
							}
						},
						axisLabel: {
							interval: 0, //x轴数据显示完整
							// rotate: 30,
							color: '#333'
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								type: 'dotted'
							}
						},
						axisLine: {
							show: false
						},
						axisLabel: {
							formatter(val) {
								if (val >= 10000) {
									return val / 10000 + '万';
								} else return val;
							}
						}
					}
				],
				color: ["#1a8dee", "#4ab2e9", "#13cdcc","#ff9023","#1a8dee", "#4ab2e9", "#13cdcc","#ff9023","#1a8dee", "#4ab2e9", "#13cdcc","#ff9023","#1a8dee", "#4ab2e9", "#13cdcc","#ff9023"],
				series: [
					{
						type: 'bar',
						stack: '投保面积', //折叠显示
						barWidth: 14,
						//name: '水稻政策性保险',
						//data: [64050, 54650, 43920, 76500, 23404, 96550, 10449, 38565, 85794, 83782, 50856, 50185]
					},
					{
						type: 'bar',
						stack: '投保面积',
						barWidth: 14,
						//name: '大豆政策性保险',
						//data: [24600, 87050, 84370, 13405, 61485, 36085, 86642, 94484, 32842, 35874, 15746, 59375]
					},
					{
						type: 'bar',
						stack: '投保面积',
						barWidth: 14,
						//name: '玉米政策性保险',
						//data: [40730, 73050, 74500, 85370, 93084, 39373, 76775, 23447, 54392, 77465, 38454, 59965]
					},

					{
						type: 'bar',
						stack: '报案面积', //折叠显示
						barWidth: 14,
						//name: '水稻政策性保险',
						//data: [95600, 98550, 49620, 44770, 87304, 95780, 15885, 39785, 86494, 93782, 87586, 58085]
					},
					{
						type: 'bar',
						stack: '报案面积',
						barWidth: 14,
						//name: '大豆政策性保险',
						//data: [26400, 87050, 84670, 87675, 74345, 34485, 38462, 94844, 66842, 38774, 57846, 59475]
					},
					{
						type: 'bar',
						stack: '报案面积',
						barWidth: 14,
						//name: '玉米政策性保险',
						//data: [49730, 53400, 74200, 85570, 29384, 32937, 19377, 23444, 54352, 74365, 34254, 59565]
					},

					{
						type: 'bar',
						stack: '理赔面积', //折叠显示
						barWidth: 14,
						//name: '水稻政策性保险',
						//data: [46020, 23350, 49220, 47400, 23014, 53570, 10285, 39855, 85294, 85382, 56086, 50785]
					},
					{
						type: 'bar',
						stack: '理赔面积',
						barWidth: 14,
						//name: '大豆政策性保险',
						//data: [26000, 87100, 84740, 14350, 10485, 30885, 38642, 85484, 38642, 38746, 57946, 59575]
					},
					{
						type: 'bar',
						stack: '理赔面积',
						barWidth: 14,
						//name: '玉米政策性保险',
						//data: [40707, 73008, 74800, 85670, 29384, 39337, 43077, 23944, 54732, 74665, 34454, 59658]
					}
				]
			}
		};
	},
	mounted() {
		// this.initMap()
	},
	watch: {},
	methods: {
		listenResize() {
			//窗口改变大小
			if (chart) {
				chart.resize();
			}
		},
		initMap(optionData) {
			//设置时间
			if (optionData.date) {
				this.option.title.subtext = optionData.date+'年' || '';
			}
			if (optionData.dataZoom) {
				this.option.dataZoom[0].show = optionData.dataZoom;
			}
			this.option.dataset = optionData.dataset || [];
			chart = echarts.init(document.getElementById(this.id));
			chart.setOption(this.option);
			if (optionData.chartHeight) {
				chart.resize({ height: optionData.chartHeight });
			} else {
				chart.resize({ height: 300 });
			}
		}
	},
	components: {}
};
</script>

<style scoped lang="less">
.o-echarts {
	min-width: 30px;
	min-height: 30px;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/SettlementClaimsChart.vue